import { locale } from "./translate";

type mode = "development" | "test" | "stage" | "production";

export const getMode = (): mode => {
  const mode = process.env.REACT_APP_MODE;
  const environment = process.env.NODE_ENV;

  if (environment === "production") {
    switch (mode) {
      case "test": {
        return "test";
      }

      case "stage": {
        return "stage";
      }

      case "production": {
        return "production";
      }

      default: {
        return "test";
      }
    }
  } else {
    return "development";
  }
};

const getStripePubKey = (): string => {
  const mode = getMode();

  const livePubKey = process.env.REACT_APP_STRIPE_LIVE_PUB_KEY || ``;
  const testPubKey = process.env.REACT_APP_STRIPE_TEST_PUB_KEY || ``;

  if (mode === "production") {
    return livePubKey;
  } else {
    return testPubKey;
  }
};

const getApiUrl = (): string => {
  const mode = getMode();

  const testUrl = process.env.REACT_APP_API_URL_TEST || ``;
  const stageUrl = process.env.REACT_APP_API_URL_STAGE || ``;
  const prodUrl = process.env.REACT_APP_API_URL || ``;

  if (mode === "production") {
    return prodUrl;
  } else if (mode === "stage") {
    return stageUrl;
  } else if (mode === "test") {
    return testUrl;
  } else if (mode === "development") {
    return testUrl;
  } else {
    return testUrl;
  }
};

export const settings = {
  publishableKey: getStripePubKey(),
  api_url: getApiUrl()
};

export const language = process.env.REACT_APP_GOOGLE_PLACES_LANGUAGE || "";
export const root_locale: locale = (process.env.REACT_APP_LOCALE ||
  "eng") as locale;

export const baseName =
  getMode() === "production"
    ? process.env.REACT_APP_BETA
      ? "/beta_services"
      : ""
    : "";

export const domain = (root_locale: locale) =>
  root_locale === "lt" ? "cleanbee.lt" : "cleanbee.ie";

export const ga_id = process.env.REACT_APP_GA_ID || "";
